import { render, staticRenderFns } from "./DashboardReports.vue?vue&type=template&id=3d31940a&scoped=true"
import script from "./DashboardReports.vue?vue&type=script&lang=js"
export * from "./DashboardReports.vue?vue&type=script&lang=js"
import style0 from "./DashboardReports.vue?vue&type=style&index=0&id=3d31940a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d31940a",
  null
  
)

export default component.exports